import { colors, glLegacyColorPalette } from '@/common/colors'
import type { ThemeOptions } from '@/store/modules/bot-view'

export const buildStyleOptions = (themeOptions: ThemeOptions): Record<string, unknown> => {
  const defaults = themeOptions.default

  return {
    bubbleFromUserTextColor: '#FFFFFF',
    bubbleTextColor: colors.botChatPrimary,
    accent: defaults.defaultAccent,
    primaryFont: 'Lexend Deca',
    avatarSize: 30,
    botAvatarInitials: 'V',
    userAvatarInitials: 'A',
    bubbleBorderRadius: '10px 10px 10px 0',
    bubbleFromUserBorderRadius: '10px 10px 0 10px',
    bubbleFromUserBackground: glLegacyColorPalette.legacyGrey6,
    bubbleBorderColor: '#F2F2F2',
    primaryHeaderText: '#f2f2f2',
    suggestedActionTextColor: '#257DA2',
    suggestedActionFontWeight: 400,
    suggestedActionBorderRadius: defaults.suggestedActionBorderRadius || 10,
    suggestedActionLayout: 'stacked',
    suggestedActionBackground: defaults.bubbleBackground,
    suggestedActionHeight: 45,
    suggestedActionBorderColor: '#257DA2',
    suggestedActionBorderWidth: 1,
    hideUploadButton: true,
    timestampColor: defaults.fontColor,
    timestampFormat: 'relative',
    sendBoxBackground: defaults.sendBoxBackground,
    sendBoxHeight: '85px',
    sendBoxPlaceholderColor: '#bcbec0',
    sendBoxBorderTop: 'solid 1px rgba(128, 128, 128, 0.26)',
    bubbleFromUserBorderColor: glLegacyColorPalette.legacyGrey6,
    bubbleBackground: '#F2F2F2',
    userBubbleBackground: glLegacyColorPalette.legacyGrey6,
    botAvatarImage: '/assets/img/bot-avatar.png',
  }
}
